import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row className="justify-content-center">
            <Col md={6} className="text-center">
            Copyright © {new Date().getFullYear()} Inventya Ltd. All
              rights reserved
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
